module.exports = __webpack_public_path__ + "static/1-84e000a464baf18576d1d3e0870011fe.jpg";